// ** React Imports
import { lazy, Suspense, useEffect } from "react"
// ** Router Components
import { HashRouter as AppRouter, Navigate, Route, Routes, useNavigate } from "react-router-dom"
// ** Utils
import { isEmpty, isUserLoggedIn } from "../utils/commonFunction"
// ** Custom Components
import LayoutWrapper from "../components/layout/LayoutWrapper"
// ** Routes & Default Routes
import { DefaultRoute, AcessRoutes } from "./routes"
// ** JWT Decode
import { jwtDecode } from "jwt-decode"
import axios from "axios"
import { useDispatch, useSelector } from "react-redux"
import { handleLogin } from "../redux/actions/login"
import ForgotPassword from "../forgotPassword"
import { Spinner } from "reactstrap"

// ** Lazy load pages
const NotAuthorized = lazy(() => import("../components/CustomComponent/notAuthorised"))
const Error = lazy(() => import("../components/CustomComponent/error"))
const Login = lazy(() => import("../login")) // Assuming there's a login page
const CardInfo = lazy(() => import("../components/CustomComponent/networkError"))

// Shown in the content area while a route chunk is still in flight, so the sidebar and navbar
// stay painted instead of the whole window going white.
const RouteLoader = () => (
  <div className='d-flex w-100 justify-content-center align-items-center' style={{ minHeight: 320 }}>
    <Spinner color='primary' />
  </div>
)

const Router = () => {
  const isValidToken = useSelector((state) => state?.userSession?.isAcess)
  console.log(isValidToken, "isValidToken")
  if (!isValidToken) {
    localStorage.clear()
    window.location.href = "/#/login"
  }
  if (!window.location.href.includes("/#/")) {
    window.location.href = "/#/login"
  }

  const FinalRoute = ({ route }) => {
    let action, resource
    const isOnline = navigator.onLine
    if (route.meta) {
      action = route.meta.action || null
      resource = route.meta.resource || null
    }

    if (
      !isUserLoggedIn() &&
      (!route.meta || !route.meta.authRoute) &&
      !route.meta?.publicRoute &&
      isOnline
    ) {
      localStorage.clear()
      return <Navigate to='/login' />
    } else if (!isValidToken) {
      localStorage.clear()
      return <Navigate to='/login' />
    } else if (route.meta?.authRoute && isUserLoggedIn()) {
      return <Navigate to={DefaultRoute} />
    } else {
      return <route.component />
    }
  }

  /**
   * One <Route> per path.
   *
   * This used to be a nested map — every route in AcessRoutes re-emitted a <Route> for every
   * other route sharing its layout — which produced ~70 duplicate Route elements with
   * duplicate keys on each render. React Router matched the same path either way, so the
   * duplicates were pure render cost.
   *
   * Suspense now sits INSIDE LayoutWrapper. Previously it wrapped the layout, so any chunk
   * fetch unmounted the sidebar and navbar along with the page; with fallback={null} that is
   * a blank white screen. Keeping the shell outside the boundary means only the content area
   * waits, and it waits on a spinner rather than on nothing.
   */
  const ResolveRoutes = () => {
    return AcessRoutes.map((route) => (
      <Route
        key={route.path}
        path={route.path}
        element={
          <LayoutWrapper>
            <Suspense fallback={<RouteLoader />}>
              <FinalRoute route={route} />
            </Suspense>
          </LayoutWrapper>
        }
      />
    ))
  }
  console.log(!isEmpty(isUserLoggedIn()), "isUserLoggedIn")
  return (
    <AppRouter basename={process.env.REACT_APP_BASENAME}>
      <Routes>
        <Route
          path='/'
          element={!isEmpty(isUserLoggedIn()) ? <Navigate to={DefaultRoute} /> : <Navigate to='/login' />}
        />
        <Route
          path='/login'
          element={
            <Suspense fallback={null}>
              <Login />
            </Suspense>
          }
        />
        <Route
          path='/misc/not-authorized'
          element={
            <Suspense fallback={null}>
              <NotAuthorized />
            </Suspense>
          }
        />
        <Route
          path='/forgot-password'
          element={
            <Suspense fallback={null}>
              <ForgotPassword />
            </Suspense>
          }
        />
        {ResolveRoutes()}
        <Route
          path='*'
          element={
            <LayoutWrapper>
              <Suspense fallback={<RouteLoader />}>
                <Error />
              </Suspense>
            </LayoutWrapper>
          }
        />
      </Routes>
    </AppRouter>
  )
}

export default Router
